import React, { PureComponent } from "react";
import { RiDeleteBin6Line, RiAddFill } from "react-icons/ri";
import { MdEdit } from "react-icons/md";
import { toast } from "react-toastify";

import { NavLink, Link } from "react-router-dom";
import UpdateVendor from "./UpdateVendor";
import AddVendor from "./AddVendor";

class AllVendors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allVendors: [],
      vendorName: "",
      factoryAddress: "",
      nextPoNumber: "",
      poPrefix: "",
      shippingTerms: "",
      paymentTerms: "",
      shippingMethod: "",
      isModalVisible: false,
      vendorDataToBePassed: {},
      isAddModelVisible: false
    };
    
    console.log(this.props);
  }

  getVendorList = async () => {
    let fetchRequest = await fetch(
      "https://dashboard.realsexdoll.info/php/vendors/vendors.php"
    );
    const getVendorData = await fetchRequest.json();
    console.log("vendors data", getVendorData);
    this.setState({ allVendors: getVendorData });
  };

  

  openModal = (data) => {
    console.log(data);
    this.setState({ vendorDataToBePassed: data });
    this.setState({ isModalVisible: true });
    // this.state.isModalVisible(true);
  };

  closeModal = () => {
    this.setState({ isModalVisible: false });
    // this.state.isModalVisible(false);
  };

  openAddModel = () => {
    this.setState({ isAddModelVisible: true });
  };

  closeAddModel = () => {
    this.setState({ isAddModelVisible: false });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  //delete vendor
  deleteVendor = (id) => {
    //console.log(id)
    fetch(
      `https://dashboard.realsexdoll.info/php/vendors/deletevendor.php?vendorId=${id}`,
      {
        method: "DELETE",
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then(() => {
        toast.success("Vendor deleted successfully");
        // Redirect to the vendor list or wherever you want after the delete
        this.props.history.push("/vendor/vendorlist");
      })
      .catch((error) => {
        console.error("Error deleting vendor:", error);
        toast.success("Vendor deleted successfully");
        this.getVendorList();
      });
  };

  componentDidMount() {
    // console.log(this.props.match.params.id)
    this.getVendorList();
  }

  render() {

    return (
      <>
        <div className="row">
          <div className="col-md-2">
            <aside className="sidebar">
              <div className="sidebar-menu">
                <ul className="list-group p-3">
                  <li className="list-group-item active" aria-current="true">
                    <a
                      className="text-decoration-none"
                      href="/cookies/orderslist"
                    >
                      Home
                    </a>
                  </li>
                  <li className="list-group-item">
                    <a className="text-decoration-none" href="#">
                      Stores
                    </a>
                  </li>
                  <NavLink to={`/vendors/vendorlist`} className="btn-base">
                    Vendors
                  </NavLink>
                </ul>
              </div>
            </aside>
          </div>
          <div className="col-md-10">
            <div className="orderlist-container p-3">
              <div className="container-fluid">
                <div className="col-12">
                  
                   <div>
                  <div className="add Vendor text-end my-4">
                    <button
                      className="btn btn-warning"
                      onClick={() => this.openAddModel()}
                    >
                      <RiAddFill />
                      AddVendor
                    </button>
                    </div>
                    {this.state.isAddModelVisible && (
                      <AddVendor handleClose={() => this.closeAddModel()} />
                    )}
                  
                  </div>

                  <div className="wrapper h-100 bg-white border border-1">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Id </th>
                          <th scope="col">Vendor Name</th>
                          <th scope="col" width="320">
                            FactoryAddress
                          </th>
                          {/* <th scope="col">NextPoNumber</th>
                            <th scope="col">POPrefix</th> */}
                          <th scope="col">Shipping Terms</th>
                          <th scope="col">Payment Terms</th>
                          <th scope="col">Shipping Method</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.allVendors.map((vendors, index) => (
                          <tr key={index}>
                            <td>{vendors.id}</td>
                            <td>{vendors.vendorName}</td>
                            <td>{vendors.factoryAddress}</td>
                            {/* <td>{vendors.nextPoNumber}</td>
                              <td>{vendors.poPrefix}</td> */}
                            <td>{vendors.shippingTerms}</td>
                            <td>{vendors.paymentTerms}</td>
                            <td>{vendors.shippingMethod}</td>
                            <td>
                              <div className="d-flex align-items-center gap-1 vendor-btn">
                                <button
                                  className="btn btn-danger "
                                  onClick={() => this.deleteVendor(vendors.id)}
                                >
                                  <RiDeleteBin6Line />
                                </button>

                                <button
                                  className="btn btn-info "
                                  onClick={() => this.openModal(vendors)}
                                >
                                  <MdEdit />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {this.state.isModalVisible && (
              <UpdateVendor
                data={this.state.vendorDataToBePassed} 
                handleClose={this.closeModal}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default AllVendors;
